import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Trans, translate } from 'react-i18next';
import { USER_TYPE } from '../../../App.js';

class Summary extends Component {

  horarioCowork = () => {
    return (
      <div className="panel-body">
        <b><h4 className="text-primary">HORARIO DE SERVICIO</h4></b>
        <h5>Lunes a viernes de 8:00am a 8:00pm</h5>
        <h5>Sabado de 9:00am a 1:00pm</h5>
        <p style={{ fontSize: 'smaller' }}>*El horario puede llegar a cambiar según el centro y días festivos</p>
        <p style={{ fontSize: 'smaller' }}>Para más información consulta el centro IOS OFFICES de tu preferencia.</p>
      </div>
    )
  }

  horarioSala = (start, end) => {
    return (
      <div className="panel-body">
        {start + " - " + end}
      </div>
    )
  }

  render() {
    const count = this.props.room.capacity;
    const paymentDetails = this.props.paymentDetails;
    const room = this.props.room;
    const endDate = moment(paymentDetails.end_date, 'YYYY-MM-DD HH:mm:ss');
    const startDate = moment(paymentDetails.start_date, 'YYYY-MM-DD HH:mm:ss');
    const { t } = this.props;

    return (
      <div className="card-panel panel panel-default card">
        <div className="panel-heading-text">
          <h4 className="panel-title">{t('dashboard.room_payment.heading_summary')}</h4>
        </div>
        <div className="panel-heading" style={{ backgroundImage: "url('" + room.picture + "')" }}>
        </div>
        <div className="panel-body">
          <div className="contenedor-flexbox">
            <div className="contenedor">
              <i className="fa fa-map-marker" aria-hidden="true"></i>
              {" "}{room.name}
            </div>
            <div className="contenedor">
              <i className="fa fa-users" aria-hidden="true">
              </i>
              {" "}Capacidad para {this.props.room.capacity} personas.
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {" "}{startDate.format('ll')}
            </div>
            <div className="contenedor">
              <i className="fa fa-clock-o" aria-hidden="true"></i>
              {" "}{startDate.format('HH:mm')} - {endDate.format('HH:mm')}
            </div>
            <div className="contenedor">
              <i className="fa fa-building-o" aria-hidden="true"></i>
              {" "}{this.props.center.name}
            </div>
          </div>
          <div className={this.props.user.member !== USER_TYPE.GUEST ? "hidden" : "panel-footer"}>
            <div className="contenedor-flexbox-card">
              <div className="col-xs-6">
                <p>{t('dashboard.room_payment.subtotal')}</p>
              </div>
              <div className="col-xs-6 text-primary">
                <p>{"$" + Number(paymentDetails.subtotal).toFixed(2) + " " + paymentDetails.currency}</p>
              </div>
              <div className="col-xs-6">
                <p>{t('dashboard.room_payment.discount')}</p>
              </div>
              <div className="col-xs-6 text-primary">
                <p>{"$" + Number(paymentDetails.credits).toFixed(2) + " " + paymentDetails.currency}</p>
              </div>
              <div className="col-xs-6">
                <p>{t('dashboard.room_payment.iva')}</p>
              </div>
              <div className="col-xs-6 text-primary">
                <p>{"$" + Number(paymentDetails.iva).toFixed(2) + " " + paymentDetails.currency}</p>
              </div>
              <div className="col-xs-6">
                <p><strong>{t('dashboard.room_payment.total')}</strong></p>
              </div>
              <div className="col-xs-6 text-primary">
                <p><strong>{"$" + Number(paymentDetails.total).toFixed(2) + " " + paymentDetails.currency}</strong></p>
              </div>
            </div>
            <div className="form-group text-center">
              <button className="btn btn-primary btn-singup btn-resvations" onClick={this.props.handlePromocodeClick}>PROMOCODE</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Summary);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/payment/Summary.js